import { breakpoint } from '../constants/breakpoint';

/**
 * Get MediaQueryList Function
 * @param { sizeType } - Break points
 * @returns { object } - MediaQueryList
 * ex: getMediaQueryList('md').addEventListener('change', (event) => {if (event.matches) {...}});
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 */

function getMediaQueryList(size, scale) {
  if (scale === 'max') {
    return window.matchMedia(`(max-width: ${breakpoint[size]})`);
  }
  return window.matchMedia(`(min-width: ${breakpoint[size]})`);
}

export { getMediaQueryList };
